import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";
import type { IRoadCategorySegments } from "../../../models/storeModels/IRoadCategorySegments";

function getInitialState(){
    const initialState: IRoadCategorySegments = {
        chosenCategoriesIds: getItemWebStorage('roadCategoryMapFilters') ?? [],
        categoryGroups: null,
        roadCategoryFilterIsOpened: false
    };
    return initialState
}

export const roadCategorySegmentsSlice = createSlice({
    name: 'roadCategorySegments',
    initialState: getInitialState(),
    reducers: {
        applyRoadCategoryFilters(state, action: PayloadAction<any>) {
            state.chosenCategoriesIds = action.payload
        },
        setCategoryGroups(state, action: PayloadAction<any>) {
            state.categoryGroups = action.payload
        },
        setRoadCategoryFilterIsOpened(state, action: PayloadAction<any>) {
            state.roadCategoryFilterIsOpened = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { applyRoadCategoryFilters, setCategoryGroups, setRoadCategoryFilterIsOpened } = roadCategorySegmentsSlice.actions
export const roadCategorySegmentsReducer = roadCategorySegmentsSlice.reducer;
